import type { FC } from 'react';
import React, { useMemo } from 'react';

import { defaultFontSize, defaultLineHeight, defaultTheme } from './config';
import { calcHeight, getClassNames, getTheme, prepareSet } from './helpers';
import type { IFontPreset, THeight, TProps, TThemeValid } from './models';

export const Text: FC<TProps> = ({
    Tag = 'p',
    // todo: на следюущей итерации добавить дефолтное значение из пропа Tag
    tag,
    dataTestId = 'text',
    children,
    className,
    decoration,
    fontSize = defaultFontSize,
    showDataNosnippet,
    fontWeight,
    kind,
    lineHeight,
    lines,
    noClasses,
    styles,
    fontPreset,
    theme = defaultTheme,
    textTransform,
    title,
    view,
    fontViews,
}) => {
    const set: IFontPreset = useMemo(
        () =>
            prepareSet({
                fontPreset,
                view,
                textTransform,
                lineHeight,
                fontWeight,
                fontSize,
                fontViews,
            }),
        [fontPreset, view, textTransform, lineHeight, fontWeight, fontSize, fontViews]
    );

    const textTheme: TThemeValid = useMemo(() => getTheme(theme), [theme]);

    const classNamesResult = useMemo(
        () => getClassNames({ set, className, textTheme, kind, decoration, noClasses, styles }),
        [set, className, textTheme, decoration, noClasses, styles, kind]
    );

    const height: THeight = useMemo(
        () =>
            calcHeight({
                lines,
                lineHeight: set.lineHeight || defaultLineHeight,
                fontSize: set.fontSize,
            }),
        [lines, set]
    );
    const TagElement = tag || Tag;

    return (
        <TagElement
            className={classNamesResult}
            data-nosnippet={showDataNosnippet ? true : undefined}
            data-test-id={dataTestId}
            style={{ height }}
            title={title}
        >
            {children}
        </TagElement>
    );
};
